<template>
  <div class="container my-5 py-lg-5">
    <div class="row gy-5 gx-5">
      <div class="col-md-6">
        <img
          src="@/assets/images/img_404.png"
          class="w-100 h-100 of--contain"
          alt="Arcux - Error 404"
        />
      </div>
      <div class="col-md-6 px-3 px-md-5">
        <h1 class="w-bold fs-40 mb-4">OOPS!</h1>
        <p>
          Vaya, parece que esta página no existe. Si necesitas ayuda
          envíanos un email a
          <strong>{{email}}</strong>
          y te ayudaremos.
        </p>

        <router-link class="c-button c-button--primary d-inline-block" to="/cursos">
          Ver cursos
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    email() {
      return process.env.VUE_APP_SUPPORT_EMAIL;
    },
  },
};
</script>
